import React from "react";

import { getTopHeadlines } from "./services/newsService";

import Base from "./common/Base";
import ArticleCard from "./components/articleCard";
import LoadMore from "./common/LoadMore";
import Loading from "./common/Loading";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      category: props.location.state,
      news: [],
      loading: true,
      loadMore: false,
      page: 1,
      totalResults: 0,
    };
  }

  async componentDidMount() {
    this.loadData();
  }

  async loadData() {
    const { news, category } = this.state;
    let moreNews = await getTopHeadlines(category);

    this.setState({
      news: [...news, ...moreNews.articles],
      totalResults: moreNews.totalResults,
      loading: false,
      loadMore: false,
    });
  }

  handleLoadMore({ page }) {
    let nextPage = page + 1;
    this.setState(
      () => ({
        page: nextPage,
        loadMore: true,
      }),
      this.loadData
    );
  }

  getAllNews({ news, loading }) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-8 col-md-8 col-lg-8 offset-sm-2 offset-md-2 offset-lg-2">
            {!loading && (
              <h4 className="text-weight-bold text-center">TOP NEWS</h4>
            )}
            {!loading &&
              news.map((unit) => <ArticleCard key={unit.title} {...unit} />)}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { news, loading, totalResults, loadMore } = this.state;
    return (
      <Base>
        {loading && <Loading />}
        {this.getAllNews(this.state)}
        {!loading && news.length < totalResults && (
          <LoadMore
            loadMore={loadMore}
            onHandleMore={() => this.handleLoadMore(this.state)}
          />
        )}
      </Base>
    );
  }
}

export default App;
